<template>
  <div class="home">
    <div class="upBox">
      <Header ref="height0" :seachIptGray="true" />
      <div class="tabBox" ref="height1">
        <pordTab ref="prodTap" :updateActiveIndex="updateActiveIndex" :tabs="tabsList" @showMask="showMask"
          @choseTabItemCb="choseTabItemCb" />
      </div>

    </div>
    <div class="mask" v-if="isExpanded"></div>
    <div class="tree-select-container" v-show="!isExpanded">
      <!-- 左侧选项列表 -->
      <div class="left-pane" :style="{ height: emptyHeight + 'px' }">
        <div v-for="(item, index) in leftOptions" :key="item.id" :class="['left-item', { active: activeIndex === index }]"
          @click="onLeftItemClick(index, item.id)">
          <div class="left-item-text">
            <p v-html="item.name"></p>
          </div>
        </div>
      </div>

      <!-- 右侧内容列表 -->
      <div class="right-pane" :style="{ height: (emptyHeight - 24) + 'px' }">
        <van-list v-model="loading" :finished="finished" @load="getChild">
          <div @click="showModelDis(item)" v-for="item in rightContentMap" :key="item.id" class="right-item">
            <div class="top">
              <div class="icon"></div>
              <div class="name">{{ item.material }} <span v-if="item.colour">（{{ item.colour }}）</span></div>
            </div>
            <div class="tags">
              <div class="tags_item" v-if="item?.kg">
                {{ item.kg }}
                </div>

                <div class="tags_item" v-if="item?.silicon">
                  {{ item.silicon }}
                </div>
         
                <div class="tags_item" v-if="item?.force">
                  {{ item.force }}
                </div>
             
            </div>
          </div>
        </van-list>

        <EmptyState
      :show="rightContentMap.length == 0 && !loading"
      :emptyHeight="(emptyHeight - 100)"
      :text="text"
    />
       
      </div>
    </div>
    <div class="pdfWarp" v-show="showPdf">
      <div class="pdfWarpHeight">
        <div class="close" @click="togglePdf">
          <img src="@/assets/images/common/close.png" alt="" srcset="">
        </div>
        <div id="pdf-container"></div>
      </div>
    </div>

    <custom-modal :visible="showModal" :prodDisData="prodDisData" button-text="下载 TDS" @close="showModal = false"
      @tag-click="handleTagClick" @button-click="handleButtonClick" />
   
  </div>
</template>
    
<script>
import { Toast } from "vant";
import Crypt from "@bluedot-tech/vue-ui/es/utils/crypt";
import config from "../config/config";
import Header from "@/components/header";
import TypeCard from "@/components/typeCard.vue";
import pordTab from "@/components/pordTab.vue";
import CustomModal from '@/components/prodPop.vue';
import EmptyState from '@/components/EmptyState.vue';
import PDFh5 from 'pdfh5';
import "pdfh5/css/pdfh5.css";

export default {
  components: {
    Header,
    TypeCard,
    pordTab,
    CustomModal,
    EmptyState
  },
  data() {
    return {
      text:"暂无产品",
      prodDisData: {

      },
      showPdf: false,
      pdfUrl: null,
      tabsList: [],
      showModal: false,
      isExpanded: false,
      curType: 0,
      childId: '',
      params: {
        type: 1,
        state: "",
        current: 1,
        s_type: "",
      },
      emptyHeight: 0,
      tabs: [],
      total: 0,
      query: null,
      list: [],
      loading: false,
      finished: false,
      updateActiveIndex: 0,
      value: "",
      searchValue: "", // 父组件维护的搜索关键词
      imageList: [

        // 添加更多图片路径
      ],

      activeIndex: 0, // 当前选中的左侧索引
      leftOptions: [


      ],
      rightContentMap: [],
    };
  },
  mounted() {
    this.initShare();
    this.query = this.$route.query;
    if(this.query.prodId){  //banner直接展示弹框
      this.getPodDis(this.query.prodId);
    }
    // this.getTabList();
    this.initShare();
    // if (this.query.id) {
    //   this.params.s_type = this.query.id;
    // }
    // 页面浏览 监测
    this.$dataStatistics({
      page_title: `产品中心`,
    },'访问');
    // this.getModuleList();
    this.calculateEmptyHeight();
  },

  methods: {
    togglePdf() {
      this.showPdf = !this.showPdf;
    },
    getPodDis(id){
      this.$http.get(`/api/platform/product/${id}`, {}).then((res)=>{
        if(res.errcode)return Toast(res.errmsg);
        this.showModelDis(res.data);
      })
    },
    choseTabItemCb({ index,tab}) {
      console.log('index ---:', index);
      this.$dataStatistics('click', '产品分类:' + tab.name);
      this.activeIndex = 0;
      this.leftOptions = this.tabsList[index].children;
      this.childId = this.tabsList[index]?.children[0]?.id;
      this.reset();
      this.getChild();
    },
    // getChild() {
    //   let params = {
    //     "filter[type]": 1,
    //     'filter[status]': this.childId
    //   };
    //   this.$http.get("/api/platform/product", { params: params }).then((res) => {
    //     this.rightContentMap = res.data;
    //     this.loading = false;
    //     this.finished = true;
    //   })
    // },
    async getTabList() {
      let params = {
        "filter[type]": 1,
      };
      let res = await this.$http.get("/api/platform/category", { params: params })
      this.tabsList = res.data;
      if (this.query.tabId) {
        this.updateActiveIndex = this.query.tabId * 1;
        this.$refs.prodTap.setIndex(this.updateActiveIndex);
       
        // this.choseTabItemCb({index:this.updateActiveIndex})
      }
      this.leftOptions = this.tabsList[this.updateActiveIndex]?.children;
      this.childId = this.tabsList[this.updateActiveIndex]?.children[0]?.id;
      if(this.query.tabId){
        this.$nextTick(()=>{
          this.$refs.prodTap.handleScroll();
        })
       
      }
      // this.getChild();
    },
    showModelDis(item) {

      this.$dataStatistics('click','查看TDS',{'page_param':{...item}});

      this.prodDisData = item;
      this.showModal = true;
    },
    handleTagClick(tag) {
      console.log('Tag clicked:', tag);
      this.showModal = false;
      let index = this.tabsList.findIndex(item => tag.id == item.id);
      this.$nextTick(()=>{
        // this.$set(this, 'updateActiveIndex', index);
        // console.log('"index" ---:',this.updateActiveIndex);
        this.$refs.prodTap.setIndex(index);
        this.$refs.prodTap.handleScroll();
      })
    
      // this.updateActiveIndex = index;
      this.choseTabItemCb({ index });
    },
    handleButtonClick(url) {
      console.log('Button clicked');
      this.userData(url);
    },
    userData(url) {
      console.log('"url" ---:', url);
      if (!url) return Toast('暂无文件')
      this.checkUser().then(res => {
        console.log('res222 ---:',res.errcode);
        if (res.errcode == 1012) {
          console.log('res ---:',res);
          
          this.$router.push('/MemberRegister')
        } else {
          this.pdfh5 = new PDFh5('#pdf-container', {
            pdfurl: url, // 替换为你的 PDF 文件路径
          });
          this.togglePdf();
        }
      })
    },
    checkUser() {
      return new Promise((resolve) => {
        let openid = this.$localStorage.getItem("openid");
        let params = { openid }
        this.$http.get("/api/platform/member/get-user-info", { params }).then((res) => {
          resolve(res.data);
        })
      });
    },
    showMask() {
      this.isExpanded = !this.isExpanded;
    },
    // 左侧选项点击事件
    onLeftItemClick(index, id) {
      if (this.activeIndex !== index) {
        this.activeIndex = index;
        this.childId = id;
        this.reset();
        this.getChild();
      }
    },
    calculateEmptyHeight() {
      this.$nextTick(() => {
        const headerHeight = this.$refs.height0.$el.offsetHeight;
        const headerHeight1 = this.$refs.height1.offsetHeight;
        console.log('headerHeight1 ---:', headerHeight1);

        const paddingBox = 79; // Padding value

        // Calculate remaining height
        const remainingHeight =
          window.innerHeight -
          headerHeight -
          headerHeight1
        this.emptyHeight = remainingHeight > 0 ? remainingHeight : 0;
      });
    },

    reset() {
      this.rightContentMap = [];
      this.loading = true;
      this.finished = false;
      this.params.current = 1;
      this.total = 0;
    },
    onLoad() {
      if (this.rightContentMap?.length < this.total) {
        this.params.current++;
        this.getChild();
      }
    },
    async getChild() {

      if (this.tabsList.length <= 0) {
        await this.getTabList();
      }

      if (this.rightContentMap?.length < this.total) {
        this.params.current++;
      }
      let params = {
        "filter[type]": this.childId,
        'filter[status]': 1,
        'current': this.params.current,
      };
      this.loading = true;
      this.$http.get("/api/platform/product", { params: params }).then((res) => {
        this.params.current = res?.data?.current;
        this.total = res?.data?.total;
        this.rightContentMap = this.rightContentMap.concat(res.data.data);
        this.$nextTick(() => {
          this.loading = false;
          if (this.rightContentMap?.length >= this.total) {
            this.finished = true;
          }
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pdfWarp {
  padding: 20px;
  width: 100%;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 11111;
  background: rgba(0, 0, 0, 0.6);

  .pdfWarpHeight {
    position: absolute;
    width: 90%;
    height: 80%;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
  }

  .close {
    position: absolute;
    right: 0px;
    top: -35px;
    width: 28px;
    height: 28px;
    img{
            width: 100%;
            height: 100%;
        }
  }
}

#pdf-container {
  position: absolute;
  width: 100%;
  height: 100%;

  /deep/ .viewerContainer {
    height: 100% !important;
  }
}

.mask {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
}

.upBox {
  z-index: 3;
  position: relative;
  background: #FFFFFF;
  border-radius: 0 0 18px 18px;
}

.empty {
  width: 100%;

  .emptyImg {
    width: 120px;
    height: 144px;
    display: block;
  }
}

.home {
  width: 100%;

  .bannerContent {
    width: 100%;
    height: 394px;
    margin: 0 auto;
  }

  .tabBox {
    z-index: 2;
    position: sticky;
    top: 128px;
  }

  .titleBox {
    font-size: 34px;
    color: #991d85;
    font-weight: bold;
    margin-top: 31px;

    .title {
      margin-left: 16px;
    }

    .line {
      width: 6px;
      height: 32px;
      background: #991d85;
      border-radius: 3px;
    }
  }

  .paddingBox {
    z-index: 1;
    position: relative;
    padding: 0 36px;
  }

  .searchBox {
    margin-top: 33px;
  }

  .listCard {
    margin-top: 30px;
  }

  .bg {
    width: 200px;
    height: 200px;

    background-size: 100% 100%;
  }
}


.tree-select-container {
  display: flex;
  height: 100%;
}

/* 左侧区域样式 */
.left-pane {
  width: 90px;
  background-color: #fafafa;
  overflow-y: auto;
}

.left-item {
  width: 90px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  white-space: pre-wrap;
  /* 支持文字换行 */
  word-break: break-word;
  text-align: center;
  position: relative;
  border-left: 4px solid transparent;
  color: #9F9F9F;
  font-size: 14px;

}

.left-item.active {
  background: linear-gradient(270deg, #FFFFFF 0%, #F2F9FF 100%);
  /* Blue/Medium Blue */
  border-left: 3px solid #0059A3;
  color: #0059A3;
}

.left-item-text {
  font-size: 14px;
}

/* 右侧区域样式 */
.right-pane {
  overflow-y: auto;
  padding-top: 0;
  width: calc(100% - 90px); /* For width */
}

.right-item {
  padding: 20px 12px 12px;
  background: linear-gradient(270deg, #FFFFFF 0%, #FFFFFF 100%);
  border-bottom: 1px solid #F5F5F5;

  .top {
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    .icon {
      width: 4px;
      height: 16px;
      background: #86BC25;
      border-radius: 2px 2px 2px 2px;
    }

    .name {
      font-size: 16px;
      color: #333333;
      margin-left: 10px;
    }
  }

  .tags {
    display: flex;
    flex-wrap: wrap;

    .tags_item {
      font-size: 12px;
      color: #9F9F9F;
      padding: 7px 12px;
      background: #F3F3F3;
      border-radius: 4px 4px 4px 4px;
      margin-right: 5px;
      margin-bottom: 4px;
    }
  }
}
</style>
    